export const TABS = ['backorder', 'ordertracking', 'orderhistory']
export const TAB_MAPPING = {
  backorder: 0,
  ordertracking: 1,
  orderhistory: 2,
}

export const ORIGINAL_CONSTANTS = {
  ORDER_NR: 'vbeln',
  POSITION_NR: 'posnr',
  NAME: 'arktx',
  SKU: 'matnr',
}

export const BATTERY_CONSTANTS = {
  IDENTIFIER: 'identifier',
  VALUE: 'value',
  SKU: 'sku',
}

export const NEW_FIELD_MAPPING = {
  AVAILABLE_AMOUNT: 'availableQuantity',
  CONFIRMED_AMOUNT: 'confirmedQuantity',
  CLASSIFICATION: 'classificationNumber',
  MATERIAL_PROVISION_DATE: 'materialAvailabilityDate',
}

export const BACKORDER_ITEM_FIELD_MAPPING = {
  AMOUNT: 'Betrag',
  GENERIC_AMOUNT: 'Menge',
  UNCONFIRMED_AMOUNT: 'unconfirmedOrdersQuantity',
  CITY: 'Ort',
  CURRENCY: 'Währung',
  DELIVERY_ADRESS: 'delivery_address',
  DELIVERY_DATE: 'Lieferdatum',
  ARTICLE_NUMBER: 'Artikelnummer',
  ITEM_SKU: 'itemSku',
  OPEN_AMOUNT: 'OffeneLieferMenge',
  ORDER: 'Auftrag',
  ORDER_DATE: 'Auftragsdatum',
  ORDER_NR: 'Bestellnummer',
  ORDER_POSITION: 'OrderPosition',
  DELIVERY_AMOUNT: 'deliveryAmount',
  AVAILABLE_AMOUNT: 'VerfügbareMenge',
  PAYMENT_TERM: 'payment_term',
  POSITION: 'Position',
  POSITION_TEXT: 'Positionstext',
  POSITION_NOTE: 'PositionsNotiz',
  STREET: 'Straße',
  ZIP: 'Postleitzahl',
  ADDRESS_ID: 'Warenempfänger',
  ADDRESS_NAME: 'WarenempfängerName',
  COUNTRY: 'Herkunftsland',
  SALES_STATUS_DEALER: 'sales_status_dealer',
  CONFIGURATION: 'configuration',
}

export const FIELD_MAPPING = {
  ID: 'id',
  ITEM_SKU: 'itemSku',
  ACTIONS: 'actions',
  ARTICLE_DESC: 'itemDescription',
  ARTICLE_DESC_DE: 'ArtikelBez',
  ARTICLE_NUMBER: 'Artikelnummer',
  ARTICLE_RECIPIENT_NAME: 'WarenempfängerName',
  ARTICLE_RECIPIENT: 'Warenempfänger',
  ARTICLE: 'Artikel',
  AVAILABILITIES: 'Verfuegbarkeiten',
  AVAILABLE_AMOUNT: 'VerfügbareMenge',
  BAAN_CUSTOMER_NUMBER: 'baan_customer_number',
  BOOKING_TYPE: 'Bestellart',
  BRAND: 'brand',
  CLASSIFICATION: 'Einteilung',
  CLASSIFICATIONS: 'Einteilungen',
  CONFIGURATION: 'configuration',
  CONFIRMED_AMOUNT: 'BestätigteMenge',
  CUMULATED_AMOUNT: 'KumulierteAuftragsmenge',
  CURRENCY: 'Währung',
  POSEX_WE: 'posexWe',
  CUSTOMER_MATERIAL: 'KundenMaterial',
  DEFAULT_CURRENCY: 'Hauswährung',
  DELIVERED_AMOUNT: 'deliveredOrdersQuantity',
  DELIVERED_ORDER_AMOUNT: 'GelieferteMenge',
  DELIVERY_CONDITION: 'Versandbedingung',
  DELIVERY_DATE: 'Lieferdatum',
  DIVISION: 'Sparte',
  EAN: 'EAN',
  GROUP: 'Gruppier',
  GROUPINGS: 'Gruppierungen',
  MATERIAL_PROVISION_DATE: 'Materialbereitstellungsdatum',
  NET_PRICE_AVAILABLE_AMOUNT: 'NettowertVerfügbareMenge',
  NET_PRICE_CUMULATED_ORDER_AMOUNT: 'NettowertKummulierteAuftragsmenge',
  NEW_POSITIONS: 'positions',
  NEXT_DELIVERY: 'nextDeliveryDate',
  ORDER_DATE: 'Auftragsdatum',
  ORDER_NR: 'Bestellnummer',
  ORDER_POS_CLASSIFICATION: 'AuftragsnummerPosEinteilung',
  ORDER_TYPE: 'Auftragsart',
  ORDER: 'Auftrag',
  ORDERED_AMOUNT: 'cumulatedOrderQuantity',
  OPEN_CONFIRMED_AMOUNT: 'openAndConfirmedOrdersQuantity',
  PAYMENT_TERM: 'payment_term',
  PLACE: 'Ort',
  POSITION_TEXT: 'Positionstext',
  POSITION: 'Position',
  POSITIONS: 'Positionen',
  PREFERRED_DELIVERY_DATE: 'WunschlieferdatumWL',
  REF_A: 'RefA',
  REF_B: 'RefB',
  SALES_DOCUMENT_VA: 'salesDocumentVA',
  SALES_ORGANIZATION: 'Verkaufsorganisation',
  SAP_CUSTOMER_NUMBER: 'sap_customer_number',
  STREET: 'Straße',
  UNCONFIRMED_AMOUNT: 'unconfirmedOrdersQuantity',
  ZIP_CODE: 'Postleitzahl',
}

export const backendSortFieldMapping = {
  Lieferdatum: 'nextDeliveryDate',
  Artikelnummer: 'itemSku',
  itemDescription: 'itemDescription',
  brand: 'brand',
  cumulatedOrderQuantity: 'cumulatedOrderQuantity',
  openAndConfirmedOrdersQuantity: 'openAndConfirmedOrdersQuantity',
  deliveredOrdersQuantity: 'deliveredOrdersQuantity',
  unconfirmedOrdersQuantity: 'unconfirmedOrdersQuantity',
  nextDeliveryDate: 'nextDeliveryDate',
}

export const exportHeaders = [
  FIELD_MAPPING.ORDER_DATE,
  FIELD_MAPPING.ORDER,
  FIELD_MAPPING.POSITION,
  FIELD_MAPPING.CLASSIFICATION,
  FIELD_MAPPING.ARTICLE,
  FIELD_MAPPING.ARTICLE_DESC_DE,
  FIELD_MAPPING.DIVISION,
  // FIELD_MAPPING.GROUP,
  FIELD_MAPPING.AVAILABLE_AMOUNT,
  FIELD_MAPPING.CUMULATED_AMOUNT,
  FIELD_MAPPING.DELIVERED_ORDER_AMOUNT,
  FIELD_MAPPING.UNCONFIRMED_AMOUNT,
  FIELD_MAPPING.DELIVERY_DATE,
  FIELD_MAPPING.ORDER_NR,
  FIELD_MAPPING.EAN,
  FIELD_MAPPING.CUSTOMER_MATERIAL,
  FIELD_MAPPING.NET_PRICE_AVAILABLE_AMOUNT,
  FIELD_MAPPING.NET_PRICE_CUMULATED_ORDER_AMOUNT,
  FIELD_MAPPING.CURRENCY,
  FIELD_MAPPING.DELIVERY_CONDITION,
  FIELD_MAPPING.ARTICLE_RECIPIENT,
  FIELD_MAPPING.ARTICLE_RECIPIENT_NAME,
  FIELD_MAPPING.STREET,
  FIELD_MAPPING.ZIP_CODE,
  FIELD_MAPPING.PLACE,
  FIELD_MAPPING.SALES_ORGANIZATION,
  FIELD_MAPPING.ORDER_TYPE,
  FIELD_MAPPING.BOOKING_TYPE,
  // FIELD_MAPPING.REF_A,
  // FIELD_MAPPING.REF_B,
  FIELD_MAPPING.ORDER_TYPE,
  FIELD_MAPPING.POSITION_TEXT,
  FIELD_MAPPING.PAYMENT_TERM,
]

export default FIELD_MAPPING
